import React from 'react'
import { Field } from './field'
import { useOrganizationSettingsQuery } from '../organization-settings/use-organization-settings'

export interface AgentUrlProps {
  organizationUuid: string
  itemSpaceCss: string
}

export const AGENT_URL_FIELD_TEST_ID = 'agent-url'

export const AgentUrlField = ({
  organizationUuid,
  itemSpaceCss
}: AgentUrlProps) => {
  const { data, isError, isLoading } = useOrganizationSettingsQuery({
    organizationUuid
  })

  if (isLoading || isError || !data) {
    return null
  }

  return (
    <div data-testid={AGENT_URL_FIELD_TEST_ID}>
      <Field
        className={itemSpaceCss}
        label={{ id: 'title_contrastAgentURL' }}
        value={data.agentUrl}
      />
    </div>
  )
}
